import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { c } from '@debbie/cortex/dist';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors';
import { Sliders } from './Icons';
import { Checkbox } from '.';
import { ExclusiveContentBadge } from './ExclusiveContent';
export const ExclusiveContentInput = (props) => {
    const { me } = props;
    const exclusiveContent = useSelector(selectExclusiveContent);
    return (React.createElement(React.Fragment, null, me && me.details.isSystemAgent && (React.createElement("div", null,
        // @ts-ignore
        React.createElement(Link, { to: "/lighthouse", style: { color: 'inherit ' } },
            React.createElement(Sliders, { style: {
                    float: 'right',
                    width: '20px',
                    height: '20px',
                    marginTop: '5px',
                    cursor: 'pointer',
                } })),
        React.createElement(Checkbox, { checked: !!(exclusiveContent === null || exclusiveContent === void 0 ? void 0 : exclusiveContent.length), onChange: () => {
                if (!(exclusiveContent === null || exclusiveContent === void 0 ? void 0 : exclusiveContent.length)) {
                    c.exclusiveContent.select([me.id]);
                }
                else {
                    c.exclusiveContent.select([]);
                }
            }, placeholder: React.createElement(ExclusiveContentBadge, null) })))));
};
export default ExclusiveContentInput;
//# sourceMappingURL=ExclusiveContentInput.js.map